import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type AppointmentCardConfig } from './appointment-card.types';

@Component({
  selector: 'app-appointment-card',
  templateUrl: './appointment-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentCard {
  readonly config = input.required<AppointmentCardConfig>();

  readonly action = output<DynamicAction>();

  protected onButtonClick(event: DynamicAction): void {
    this.action.emit(event);
  }
}
